import React, { useMemo } from 'react';
import { splitPasukWords } from '../utils/pasuk';

interface PasukWordsProps {
  hebrew: string;
  /** Word being read right now (karaoke), or -1 for none. */
  activeIndex?: number;
  className?: string;
}

/** Pasuk text split into words so the word being read can be colored. */
const PasukWords: React.FC<PasukWordsProps> = ({ hebrew, activeIndex = -1, className = '' }) => {
  const words = useMemo(() => splitPasukWords(hebrew), [hebrew]);
  return (
    <p dir="rtl" lang="he" className={className}>
      {words.map(({ word, joiner }, i) => (
        <React.Fragment key={i}>
          <span
            className={`rounded-md transition-colors duration-150 ${
              i === activeIndex ? 'bg-school-primary-soft text-school-primary' : ''
            }`}
          >
            {word}
          </span>
          {i < words.length - 1 ? joiner : null}
        </React.Fragment>
      ))}
    </p>
  );
};

export default PasukWords;
